// https://data-portal.internal.atlassian.com/targeting/traits/9b3a033f-c94a-4fb4-b3cb-ac766d791a49
export const IS_CCP_BILLING_ADMIN_TRAIT = 'jira_software_free_is_ccp_billing_admins';
